import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import kixieLogoFullRedCroppedAnimated from '../../../images/Kixie-Logo-Full-Red-Cropped-Animated.svg';

const useStyles = makeStyles((theme) => ({
  root: (props: { occupiedHeight?: number }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: props.occupiedHeight
      ? `calc(100vh - ${props.occupiedHeight}px)`
      : '100%',
  }),
}));

export function PageLoading(props: {
  /** Total height of existing elements on page */
  occupiedHeight?: number;
}) {
  const classes = useStyles({
    occupiedHeight: props.occupiedHeight,
  });
  return (
    <p className={classes.root}>
      <img
        src={kixieLogoFullRedCroppedAnimated}
        alt="Kixie"
        height="74px"
        width="182px"
      />
    </p>
  );
}
